import React from "react";
import { Container, Grid, Typography, Link } from "@mui/material";
import { PageContainer } from "@packsize/components";
import { FormattedMessage } from "react-intl";
import { Link as RouterLink } from "react-router-dom";

export const NotFound: React.FC = () => {
	return (
		<PageContainer>
			<Container maxWidth="md">
				<Grid container gap={4} direction="column">
					<Typography variant="h1">
						<FormattedMessage id="Lost in the digital wilderness" defaultMessage="Lost in the digital wilderness" />
					</Typography>

					<Typography>
						<FormattedMessage
							id="Looks like you wandered off into the digital wilderness and got yourself lost."
							defaultMessage="Looks like you wandered off into the digital wilderness and got yourself lost."
						/>
					</Typography>

					<Link component={RouterLink} to="/" replace>
						<FormattedMessage id="Take me home" defaultMessage="Take me home" />
					</Link>
				</Grid>
			</Container>
		</PageContainer>
	);
};
